module.exports = __webpack_public_path__ + "static/media/supportChat.d886abac.svg";